import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  updateMediaGallery = (event) => {
    const newMediaGallery = event.detail.data.html.querySelector('product-media-gallery slider-component');
    const currentMediaGallery = this.querySelector('slider-component');

    if (!newMediaGallery || !currentMediaGallery) return;

    if (currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.replaceWith(newMediaGallery);
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}
// Lecture automatique des vidéos produit (compatibilité Rubik Variant Images)
(() => {
  const playAll = () =>
    document.querySelectorAll('product-media-gallery deferred-media[autoplay] video').forEach((v) => {
      v.muted = true;
      if (v.paused) v.play().catch(() => {});
    });
  let timer;
  const start = () => {
    const gallery = document.querySelector('product-media-gallery');
    if (!gallery) return;
    playAll();
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(playAll, 250);
    }).observe(gallery, { childList: true, subtree: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();